import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";
import { setSectionsCache, useSections, type SectionsMode } from "@/lib/sections";

const MODES: SectionsMode[] = ["both", "events", "spots"];

export const CustomerSectionsSettings = () => {
  const { t } = usePrefs();
  const { mode } = useSections();
  const [v, setV] = useState<SectionsMode>("both");
  useEffect(() => { if (mode) setV(mode); }, [mode]);
  const save = async () => {
    try { const r = await api.put("/admin/platform/sections", { mode: v }); setSectionsCache(r.data.mode); toast.success(t("cs.saved")); } catch (e) { toast.error(errorText(e, t)); }
  };
  return (
    <div data-testid="customer-sections-settings" className="rounded-3xl border bg-card p-5 space-y-3">
      <p className="font-bold flex items-center gap-2"><Eye className="h-5 w-5 text-primary" />{t("cs.title")}</p>
      <p className="text-sm text-muted-foreground">{t("cs.note")}</p>
      <div className="grid gap-2 sm:grid-cols-3" role="radiogroup">
        {MODES.map((m) => (
          <button key={m} type="button" role="radio" aria-checked={v === m} onClick={() => setV(m)} data-testid={`customer-sections-${m}`}
            className={`rounded-2xl border p-3 text-start transition-[background-color,border-color] ${v === m ? "border-primary bg-primary/10" : "hover:bg-accent"}`}>
            <p className="font-bold text-sm">{t(`cs.${m}`)}</p>
            <p className="text-xs text-muted-foreground">{t(`cs.${m}Note`)}</p>
          </button>
        ))}
      </div>
      <button onClick={save} disabled={v === mode} data-testid="customer-sections-save" className="h-10 px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold disabled:opacity-50 active:scale-95 transition-transform">{t("common.save")}</button>
    </div>
  );
};
